module.exports = __webpack_public_path__ + "img/rca-rs-menu2.f205eec3.jpg";